module.exports = __webpack_public_path__ + "static/media/alert-purple.c53a3fdc.svg";